import { publish } from '@theme/global';

const KEY = 'fivl:compare';
const ROWS = ['media', 'price', 'vendor', 'type', 'rating', 'availability', 'options', 'description', 'tags', 'action'];

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch (error) {
    return [];
  }
};
const write = (list) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch (error) {
    /* ignore */
  }
  document.dispatchEvent(new CustomEvent('fivl:compare', { detail: list }));
};

class ProductCompare extends HTMLElement {
  connectedCallback() {
    this.max = Number(this.dataset.max) || 4;
    this.items = this.querySelector('[data-compare-items]');
    this.count = this.querySelector('[data-compare-count]');
    this.table = this.querySelector('[data-compare-table]');
    this.dialog = this.querySelector('theme-dialog');
    this.labels = window.FIVL.strings.compare || {};
    this.cache = new Map();

    this.querySelector('[data-compare-open]')?.addEventListener('click', () => this.open());
    this.querySelector('[data-compare-clear]')?.addEventListener('click', () => write([]));
    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-compare-toggle]');
      if (toggle) {
        event.preventDefault();
        this.toggle(toggle.dataset.compareToggle);
      }
      const remove = event.target.closest('[data-compare-remove]');
      if (remove) this.remove(remove.dataset.compareRemove);
    });
    document.addEventListener('fivl:compare', () => this.render());
    document.addEventListener('fivl:content', () => this.syncButtons());
    this.render();
  }

  toggle(handle) {
    const list = read();
    if (list.includes(handle)) {
      write(list.filter((h) => h !== handle));
      return;
    }
    if (list.length >= this.max) {
      list.shift();
    }
    write([...list, handle]);
  }

  remove(handle) {
    write(read().filter((h) => h !== handle));
    if (this.dialog?.dialog?.open) this.open();
  }

  syncButtons() {
    const list = read();
    document.querySelectorAll('[data-compare-toggle]').forEach((button) => {
      button.setAttribute('aria-pressed', String(list.includes(button.dataset.compareToggle)));
    });
  }

  async render() {
    const list = read();
    this.syncButtons();
    this.hidden = list.length === 0;
    if (this.count) this.count.textContent = `(${list.length})`;
    if (!this.items) return;
    this.items.innerHTML = '';
    for (const handle of list) {
      const thumb = document.createElement('span');
      thumb.className = 'compare-bar__thumb';
      const img = document.querySelector(`[data-compare-toggle="${handle}"]`)?.closest('product-card')?.querySelector('img');
      if (img) thumb.innerHTML = `<img src="${img.currentSrc || img.src}" alt="">`;
      thumb.insertAdjacentHTML('beforeend', `<button type="button" class="compare-bar__remove" data-compare-remove="${handle}" aria-label="${this.labels.remove || 'Remove'}">×</button>`);
      this.items.append(thumb);
    }
  }

  async open() {
    const list = read();
    if (!this.dialog) return;
    this.dialog.open(this.querySelector('[data-compare-open]'));
    this.table.innerHTML = '<div class="quick-add__loading"><span class="loading-spinner"></span></div>';
    if (!list.length) {
      this.table.innerHTML = `<p class="compare-empty">${this.labels.empty || ''}</p>`;
      return;
    }
    const columns = await Promise.all(
      list.map(async (handle) => {
        if (this.cache.has(handle)) return this.cache.get(handle);
        try {
          const response = await fetch(`${window.FIVL.routes.root.replace(/\/$/, '')}/products/${handle}?section_id=compare-product`);
          const text = await response.text();
          const col = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-compare-column]');
          this.cache.set(handle, col);
          return col;
        } catch (error) {
          return null;
        }
      })
    );
    const valid = columns.filter(Boolean);
    const table = document.createElement('div');
    table.className = 'compare-table';
    table.style.setProperty('--cols', String(valid.length));
    ROWS.forEach((row) => {
      const cells = valid.map((col) => col.querySelector(`[data-row="${row}"]`)?.innerHTML || '');
      if (row !== 'media' && row !== 'action' && cells.every((c) => !c.trim() || c.trim() === '—')) return;
      const label = row === 'media' || row === 'action' ? '' : this.labels[row] || row;
      table.insertAdjacentHTML(
        'beforeend',
        `<div class="compare-table__row"><div class="compare-table__label">${label}</div>${cells.map((c) => `<div>${c}</div>`).join('')}</div>`
      );
    });
    this.table.innerHTML = '';
    this.table.append(table);
    publish('compare:open', { handles: list });
  }
}
if (!customElements.get('product-compare')) customElements.define('product-compare', ProductCompare);
